import { render } from "./BookSearchComponent.vue?vue&type=template&id=65edf964&scoped=true"
import script from "./BookSearchComponent.vue?vue&type=script&lang=js"
export * from "./BookSearchComponent.vue?vue&type=script&lang=js"

import "./BookSearchComponent.vue?vue&type=style&index=0&id=65edf964&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65edf964"]])

export default __exports__